import ReactGA from "react-ga4";

export const onTenantClick = (id, page, fromParent = null) => {
  ReactGA.gtag("set", "user_properties", {"Tenant": id});
  localStorage.setItem('tenant', id);
  fromParent && localStorage.setItem('onParentClick', true);
  window.location.assign(page);
}
